
const API_BASE =
  (import.meta?.env?.REACT_APP_API_BASE ??
   process.env.REACT_APP_API_BASE ??
   "") // empty -> same origin

  .replace(/\/$/, "");

/**
 * fetchJSON('/api/actions', { csrf: liveCsrfToken, jwt: authToken })
 */
export async function fetchJSON(path, { csrf, jwt, ...init } = {}) {
  const url = `${API_BASE}${path}`;
  const res = await fetch(url, {
    credentials: "include",     // <-- send cookies
    headers: {
      "Accept": "application/json",
      "Content-Type": "application/json",
      ...(csrf ? { "x-csrf-token": csrf } : {}),
      ...(jwt  ? { "Authorization": `Bearer ${jwt}` } : {}),
      ...(init.headers || {})
    },
    ...init
  });

  const ct = res.headers.get("content-type") || "";
  const text = await res.text();

  if (!res.ok) {
    console.error(`[API] ${url} ${res.status}:`, text.slice(0, 200));
    throw new Error(`HTTP ${res.status}`);
  }
  if (!ct.includes("application/json")) {
    console.error(`[API] Non-JSON from ${url}:`, text.slice(0, 200));
    throw new Error("Non-JSON");
  }
  return JSON.parse(text);
}



export const getShippingPreferences = async (userId) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE}/api/get/shipping-preferences/${userId}`, {
      method: 'GET',
      credentials: 'include', // Ensure session cookies are sent with the request
    }); 
      
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
  
      const data = await response.json();
      return data;
    } catch (error) {
      // Handle errors, e.g., log or throw a custom error
      console.error('Error fetching shipping preferences:', error);
      throw error;
    }
  };

  export const getInfoForSelectedCards = async (userCardIds) => {
    console.log('userCardIds',userCardIds)
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE}/api/get/cardInfoFromSelectedList/${userCardIds}`, {
      method: 'GET',
      credentials: 'include', // Ensure session cookies are sent with the request
    }); 
      
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
  
      const data = await response.json();
      return data;
    } catch (error) {
      // Handle errors, e.g., log or throw a custom error
      console.error('Error fetching shipping preferences:', error);
      throw error;
    }
  };